import { withBasePath } from "@/helpers/basePath";

export const valuePropImagePath: string = withBasePath("/images/value-props/");
